import { render, staticRenderFns } from "./PromotionHeader.vue?vue&type=template&id=181b433c&scoped=true&"
import script from "./PromotionHeader.vue?vue&type=script&lang=js&"
export * from "./PromotionHeader.vue?vue&type=script&lang=js&"
import style0 from "./PromotionHeader.vue?vue&type=style&index=0&id=181b433c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181b433c",
  null
  
)

export default component.exports